import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { LightBulbIcon } from '../../components/svgs/icons/LightBulbIcon';
import { THEME } from '../Theme/theme';

export interface UnsavedChangesWarningProps {
	/** Whether to show the warning banner */
	hasUnsavedChanges: boolean;
	/** Message to display in the warning banner */
	message?: string;
	/** Optional additional className for styling overrides */
	className?: string;
	/** Test ID for automated testing */
	testId?: string;
}

export const UnsavedChangesWarning: React.FC<UnsavedChangesWarningProps> = ({
	hasUnsavedChanges,
	message = 'You have unsaved changes.',
	className,
	testId = 'unsaved-changes-warning',
}) => {
	if (!hasUnsavedChanges) {
		return null;
	}

	return (
		<div
			role='alert'
			aria-live='polite'
			className={className ? `${css(styles.warningMessage)} ${className}` : css(styles.warningMessage)}
			data-testid={testId}
		>
			<span className={css(styles.messageContent)}>
				<LightBulbIcon width={16} height={16} fill={THEME.colors.info.text} styles={[styles.icon]} />
				{message}
			</span>
		</div>
	);
};

const styles = StyleSheet.create({
	warningMessage: {
		background: THEME.colors.info.light,
		fontSize: 14,
		textAlign: 'center',
		padding: 11,
		position: 'relative',
		zIndex: 1,
		marginBottom: 20,
		animationName: {
			from: {
				opacity: 0,
				transform: 'translateY(-10px)',
			},
			to: {
				opacity: 1,
				transform: 'translateY(0)',
			},
		},
		animationDuration: '300ms',
		animationTimingFunction: 'ease-out',
		animationFillMode: 'both',
	},
	messageContent: {
		display: 'inline-flex',
		alignItems: 'center',
		gap: 8,
	},
	icon: {
		flexShrink: 0,
		marginLeft: 4,
	},
});
